<template>
  <div class="find-navi-loading">
    <div class="find-navi-loading__icon"></div>
  </div>
  <div class="find-navi-error">
    <p class="c-text-md">
      データが取得できませんでした
    </p>
  </div>
  <div
    id="js-find-navi-pc-fixed-nav"
    class="p-find-navi-pc-fixed-nav"
    data-show-exclude=".p-find-navi-pickup-wrapper"
  >
    <a href="/entry/" class="c-button-square">
      <i class="c-icon" aria-hidden="true">
        <svg class="svg-icon_return-dims">
          <use xlink:href="/cms/wp-content/themes/mizuho-bp/assets/img/shared/sprite.symbol.svg#icon_entry"></use>
        </svg>
      </i>
      エントリー
    </a>
    <div class="p-find-navi-pc-fixed-nav__total-count">
      検索結果<strong class="c-text-xl">{{ animatedNum }}</strong>件
    </div>
  </div>
  <nav class="p-find-navi-nav-sp-toggle u-visible--sm-down">
    <button
      type="button"
      class="c-button p-find-navi-nav-sp-toggle__filter-button"
      :class="{'is-active': ( selectedCategory.catArea.length > 0)}"
      @click="toggleCatNav('spNav')"
    >
      <i class="c-icon left" aria-hidden="true">
        <svg class="svg-icon_equalizer-dims">
          <use xlink:href="/cms/wp-content/themes/mizuho-bp/assets/img/shared/sprite.symbol.svg#icon_equalizer"></use>
        </svg>
      </i>
      お仕事条件絞り込み
    </button>
    <div class="p-find-navi-nav-sp-toggle__show-mode">
      <div class="p-find-navi-nav-sp-toggle__show-mode__button">
        <input
          id="sp-show-mode-1"
          v-model="state.showMode"
          :class="{'is-current': ( state.showMode == '1')}"
          name="showMode"
          value="1"
          type="radio"
          checked
          @change="setStoredFilter"
        >
        <label for="sp-show-mode-1">
          <i class="c-icon left" aria-hidden="true">
            <svg class="svg-icon_newarrival-dims">
              <use xlink:href="/cms/wp-content/themes/mizuho-bp/assets/img/shared/sprite.symbol.svg#icon_newarrival"></use>
            </svg>
          </i>
          <span>新着順</span>
        </label>
      </div>
      <div
        class="p-find-navi-nav-sp-toggle__show-mode__button"
        :class="{'is-disabled': (state.bookMarkIds.length == 0) }"
      >
        <input
          id="sp-show-mode-2"
          v-model="state.showMode"
          :class="{'is-current': ( state.showMode == '2')}"
          name="showMode"
          value="2"
          type="radio"
          @change="showBookmark"
        >
        <label for="sp-show-mode-2">
          <i class="c-icon left" aria-hidden="true">
            <svg class="svg-icon_check-dims">
              <use xlink:href="/cms/wp-content/themes/mizuho-bp/assets/img/shared/sprite.symbol.svg#icon_check"></use>
            </svg>
          </i>
          <span>ブックマーク<span class="bookmark-num" aria-hidden="true">{{ state.bookMarkIds.length }}</span>件</span>
        </label>
      </div>
    </div>
  </nav>
  <div class="p-find-navi-pickup-wrapper-2">
    <div class="l-container">
      <h2 class="p-find-navi-pickup__title">ピックアップ求人</h2>
    </div>
    <div class="p-find-navi-pickup-wrapper">
      <div v-show="state.pickupJobData.length > 0" class="p-find-navi-pickup">
        <div class="p-find-navi-pickup__inner">
          <div id="js-find-navi-pickup__slider" class="swiper p-find-navi-pickup__slider">
            <div class="swiper-wrapper">
              <div
                v-for="item in state.pickupJobData"
                :key="item.id"
                class="swiper-slide"
              >
                <article class="p-find-navi-pickup__card">
                  <a :href="item.articleUrl">
                    <div class="p-find-navi-pickup__card__image-box">
                      <span class="c-icon-working-style">{{ item.workingStyle }}</span>
                      <figure>
                        <img
                          :src="item.thumbnail"
                          alt=""
                          width="520"
                          height="320"
                        >
                      </figure>
                      <div class="p-find-navi-pickup__card__image-box__text">
                        <p class="p-find-navi-pickup__card__category c-text-md u-color--key u-weight--bold">
                          <span class="operation-category">{{ item.operationCategory }}</span>
                          <span class="job-category">{{ item.jobCategory }}</span>
                        </p>
                        <div class="p-find-navi-pickup__card__lead">
                          <p class="c-text-md u-weight--bold u-color--white c-text-trim-2">{{ item.catchCopy }}</p>
                        </div>
                      </div>
                    </div>
                    <div class="l-box-xs">
                      <h2 class="c-text-md u-weight--bold">{{ item.title }}</h2>
                      <div class="l-gap--xs">
                        <p class="c-text-sm">{{ item.address }}</p>
                      </div>
                    </div>
                  </a>
                </article>
              </div>
            </div>
          </div>
          <div class="p-find-navi-pickup__pagination-container">
            <div class="swiper-pagination p-find-navi-pickup__pagination"></div>
          </div>
          <button
            type="button"
            class="p-find-navi-pickup__prev swiper-button-prev"
            aria-label="前へ"
          >
            <i class="c-icon" aria-hidden="true"></i>
          </button>
          <button
            type="button"
            class="p-find-navi-pickup__next swiper-button-next"
            aria-label="次へ"
          >
            <i class="c-icon" aria-hidden="true"></i>
          </button>
        </div>
      </div>
    </div>
  </div>
  <div class="l-container">
    <div id="p-find-navi-top" class="u-anchor-target"></div>
    <div class="p-find-navi-wrapper">
      <label
        v-if="state.showMode === '2'"
        class="p-find-navi-nav__back-button c-button c-button--thin"
      >
        <input
          id="backUpdateOrder"
          v-model="state.showMode"
          name="showMode"
          value="1"
          type="radio"
          @change="setStoredFilter"
        >
        <span>
          <i class="c-icon left" aria-hidden="true">
            <svg class="svg-icon_return-dims">
              <use xlink:href="/cms/wp-content/themes/mizuho-bp/assets/img/shared/sprite.symbol.svg#icon_return"></use>
            </svg>
          </i>
          新着順に戻る
        </span>
      </label>

      <transition name="vue-find-navi">
        <nav
          v-if="state.media.isDesktop || state.visibleCat != ''"
          id="find-navi-nav"
          class="p-find-navi-nav"
          :class="{'is-disabled': ( state.showMode == '2')}"
        >
          <div class="p-find-navi-nav-sp-header-area">
            <h2 class="p-find-navi-nav-sp-header-area__title">
              <i class="c-icon left" aria-hidden="true">
                <svg class="svg-icon_equalizer-dims">
                  <use xlink:href="/cms/wp-content/themes/mizuho-bp/assets/img/shared/sprite.symbol.svg#icon_equalizer"></use>
                </svg>
              </i>
              お仕事条件絞り込み
            </h2>
            <button
              type="button"
              class="p-find-navi-nav-sp-header-area__close-button"
              @click="toggleCatNav()"
            >
              <span class="icon" aria-hidden="true"></span>
              <span class="text">閉じる</span>
            </button>
          </div>
          <button
            type="button"
            class="p-find-navi-nav__store-button c-button c-button--thin u-visible--sm"
            @click="saveSearchFilter('cookie')"
          >
            <i class="c-icon left" aria-hidden="true">
              <svg class="svg-icon_save-dims">
                <use xlink:href="/cms/wp-content/themes/mizuho-bp/assets/img/shared/sprite.symbol.svg#icon_save"></use>
              </svg>
            </i>
            絞り込み条件を保存
          </button>
          <div class="p-find-navi-nav__storage-buttons u-visible--sm">
            <button
              type="button"
              @click="setStoredFilter('cookie')"
            >
              保存条件で表示
            </button>
            <button
              type="button"
              @click="resetSearchFilter"
            >
              絞り込みを解除
            </button>
          </div>
          <div class="l-gap--xs u-visible--sm">
            <label class="p-find-navi-nav__mizuho-filter-button">
              <input
                id="isMizuhoGroup"
                v-model="selectedCategory.isMizuhoGroup"
                name="isMizuhoGroup"
                value="true"
                type="checkbox"
              >
              <span class="c-button c-button--thin c-button--border u-width--12">
                <i class="c-icon left" aria-hidden="true">
                  <svg class="svg-icon_funnel-dims">
                    <use xlink:href="/cms/wp-content/themes/mizuho-bp/assets/img/shared/sprite.symbol.svg#icon_funnel"></use>
                  </svg>
                </i>
                <span>みずほグループのお仕事に絞る</span>
              </span>
            </label>
          </div>
          <div
            v-if="state.media.isDesktop || state.visibleCat === 'spNav'"
            class="p-find-navi-nav__filter-wrapper"
          >
            <div class="p-find-navi-nav-sp__mizuho-filter-wrapper u-visible--sm-down">
              <label class="p-find-navi-nav-sp__mizuho-filter-button">
                <input
                  id="isMizuhoGroup"
                  v-model="selectedCategory.isMizuhoGroup"
                  name="isMizuhoGroup"
                  value="true"
                  type="checkbox"
                >
                <span class="c-button c-button--thin c-button--border u-width--12">
                  <i class="c-icon left" aria-hidden="true">
                    <svg class="svg-icon_funnel-dims">
                      <use xlink:href="/cms/wp-content/themes/mizuho-bp/assets/img/shared/sprite.symbol.svg#icon_funnel"></use>
                    </svg>
                  </i>
                  <span>みずほグループのお仕事に絞る</span>
                </span>
              </label>
              <div class="p-find-navi-nav-sp__total-count">
                検索結果<span class="p-find-navi-nav-sp__total-count__number"><strong>{{ animatedNum }}</strong>件</span>
              </div>
            </div>
            <div class="p-find-navi-nav__category-wrapper">
              <section
                v-if="catArea.data.value.length > 0"
                class="p-find-navi-nav__category l-gap--md-2 u-mt-sm-down--none"
              >
                <h2 class="p-find-navi-nav__category__title">
                  {{ catArea.label.value }}
                </h2>
                <ul class="p-find-navi-nav__category__values p-find-navi-nav__category__values--sp-inline">
                  <li
                    v-for="cat in catArea.data.value"
                    :key="cat.key"
                  >
                    <label class="p-find-navi-nav__category__button">
                      <input
                        :id="catArea.name.value + '-' + cat"
                        v-model="selectedCategory.catArea"
                        :name="catArea.name.value"
                        :value="cat"
                        type="checkbox"
                        @click="toggleSelectArea"
                      >
                      <span>{{ cat }}</span>
                    </label>
                  </li>
                </ul>
                <div class="l-gap--sm u-mt-sm-down--none u-border-top--sm-down">
                  <h2 class="p-find-navi-nav__category__title">
                    {{ catLocation.label.value }}
                  </h2>
                </div>
                <div v-if="getFilterLocationList.length === 0" class="p-find-navi-nav__location-text">
                  <p class="c-text-sm u-color--disabled">
                    エリアを選択すると表示されます
                  </p>
                </div>
                <ul v-if="getFilterLocationList.length > 0" class="p-find-navi-nav__category__values p-find-navi-nav__category__values--sp-inline">
                  <li
                    v-for="cat in getFilterLocationList"
                    :key="cat.key"
                  >
                    <label class="p-find-navi-nav__category__button">
                      <input
                        :id="catLocation.name.value + '-' + cat"
                        v-model="selectedCategory.catLocation"
                        :name="catLocation.name.value"
                        :value="cat"
                        v-bind="checkedCategory"
                        type="checkbox"
                      >
                      <span>{{ cat }}</span>
                    </label>
                  </li>
                </ul>
              </section>

              <section
                v-if="catOperationCategory.data.value.length > 0"
                class="p-find-navi-nav__category l-gap--sm u-mt-sm-down--xss"
              >
                <h2 class="p-find-navi-nav__category__title">
                  {{ catOperationCategory.label.value }}
                </h2>
                <ul class="p-find-navi-nav__category__values">
                  <li
                    v-for="cat in catOperationCategory.data.value"
                    :key="cat.key"
                  >
                    <label class="p-find-navi-nav__category__button">
                      <input
                        :id="catOperationCategory.name.value + '-' + cat"
                        v-model="selectedCategory.catOperationCategory"
                        :name="catOperationCategory.name.value"
                        :value="cat"
                        v-bind="checkedCategory"
                        type="checkbox"
                      >
                      <span>{{ cat }}</span>
                    </label>
                  </li>
                </ul>
              </section>

              <section
                v-if="catJobCategory.data.value.length > 0"
                class="p-find-navi-nav__category l-gap--sm u-mt-sm-down--xss"
              >
                <h2 class="p-find-navi-nav__category__title">
                  {{ catJobCategory.label.value }}
                </h2>
                <ul class="p-find-navi-nav__category__values">
                  <li
                    v-for="cat in catJobCategory.data.value"
                    :key="cat.key"
                  >
                    <label class="p-find-navi-nav__category__button">
                      <input
                        :id="catJobCategory.name.value + '-' + cat"
                        v-model="selectedCategory.catJobCategory"
                        :name="catJobCategory.name.value"
                        :value="cat"
                        v-bind="checkedCategory"
                        type="checkbox"
                      >
                      <span>{{ cat }}</span>
                    </label>
                  </li>
                </ul>
              </section>

              <section
                v-if="catWorkingStyle.data.value.length > 0"
                class="p-find-navi-nav__category l-gap--sm u-mt-sm-down--xss"
              >
                <h2 class="p-find-navi-nav__category__title">
                  {{ catWorkingStyle.label.value }}
                </h2>
                <ul class="p-find-navi-nav__category__values">
                  <li
                    v-for="cat in catWorkingStyle.data.value"
                    :key="cat.key"
                  >
                    <label class="p-find-navi-nav__category__button">
                      <input
                        :id="catWorkingStyle.name.value + '-' + cat"
                        v-model="selectedCategory.catWorkingStyle"
                        :name="catWorkingStyle.name.value"
                        :value="cat"
                        v-bind="checkedCategory"
                        type="checkbox"
                      >
                      <span>{{ cat }}</span>
                    </label>
                  </li>
                </ul>
              </section>

              <section
                v-if="catWorkSystem.data.value.length > 0"
                class="p-find-navi-nav__category l-gap--sm u-mt-sm-down--xss"
              >
                <h2 class="p-find-navi-nav__category__title">
                  {{ catWorkSystem.label.value }}
                </h2>
                <ul class="p-find-navi-nav__category__values">
                  <li
                    v-for="cat in catWorkSystem.data.value"
                    :key="cat.key"
                  >
                    <label class="p-find-navi-nav__category__button">
                      <input
                        :id="catWorkSystem.name.value + '-' + cat"
                        v-model="selectedCategory.catWorkSystem"
                        :name="catWorkSystem.name.value"
                        :value="cat"
                        v-bind="checkedCategory"
                        type="checkbox"
                      >
                      <span>{{ cat }}</span>
                    </label>
                  </li>
                </ul>
              </section>

              <section
                v-if="catOther.data.value.length > 0"
                class="p-find-navi-nav__category l-gap--sm u-mt-sm-down--xss"
              >
                <h2 class="p-find-navi-nav__category__title">
                  {{ catOther.label.value }}
                </h2>
                <ul class="p-find-navi-nav__category__values">
                  <li
                    v-for="cat in catOther.data.value"
                    :key="cat.key"
                  >
                    <label class="p-find-navi-nav__category__button">
                      <input
                        :id="catOther.name.value + '-' + cat"
                        v-model="selectedCategory.catOther"
                        :name="catOther.name.value"
                        :value="cat"
                        v-bind="checkedCategory"
                        type="checkbox"
                      >
                      <span>{{ cat }}</span>
                    </label>
                  </li>
                </ul>
              </section>
            </div>
          </div>

          <div id="js-find-navi-nav__sp-global-buttons" class="p-find-navi-nav-sp__global-buttons">
            <div class="l-row">
              <div class="l-col-9">
                <button
                  type="button"
                  class="c-button c-button--white c-button--thin"
                  @click="toggleCatNav()"
                >
                  <i class="c-icon left" aria-hidden="true"><svg class="svg-icon_work-dims"><use xlink:href="/cms/wp-content/themes/mizuho-bp/assets/img/shared/sprite.symbol.svg#icon_work"></use></svg></i>
                  この条件でお仕事を探す
                </button>
              </div>
              <div class="l-col-3">
                <button
                  type="button"
                  class="c-button c-button--border c-button--thin p-find-navi-nav-sp__reset-button"
                  @click="resetSearchFilter"
                >
                  絞り込み<br>解除
                </button>
              </div>
              <div class="l-col-6">
                <button
                  type="button"
                  class="c-button c-button--thin p-find-navi-nav-sp__conditions-button"
                  @click="saveSearchFilter('cookie')"
                >
                  <i class="c-icon left" aria-hidden="true">
                    <svg class="svg-icon_save-dims">
                      <use xlink:href="/cms/wp-content/themes/mizuho-bp/assets/img/shared/sprite.symbol.svg#icon_save"></use>
                    </svg>
                  </i>
                  絞り込み条件を保存
                </button>
              </div>
              <div class="l-col-6">
                <button
                  type="button"
                  class="c-button c-button--thin p-find-navi-nav-sp__conditions-button"
                  @click="setStoredFilter('cookie')"
                >
                  <i class="c-icon left" aria-hidden="true">
                    <svg class="svg-icon_load-dims">
                      <use xlink:href="/cms/wp-content/themes/mizuho-bp/assets/img/shared/sprite.symbol.svg#icon_load"></use>
                    </svg>
                  </i>
                  保存した条件を反映
                </button>
              </div>
            </div>
          </div>
        </nav>
      </transition>
      <div class="p-find-navi">
        <div class="p-find-navi-bookmark-desc">
          <i class="c-icon" aria-hidden="true">
            <svg class="svg-icon_check-dims">
              <use xlink:href="/cms/wp-content/themes/mizuho-bp/assets/img/shared/sprite.symbol.svg#icon_check"></use>
            </svg>
          </i>
          <div class="p-find-navi-bookmark-desc__text">
            <p class="c-text-sm u-color--key u-weight--bold">
              ブックマーク機能をご利用ください
            </p>
            <p class="c-text-sm u-color--key">
              気になる案件を最大15件ブックマークできます。保存期間は30日です。
            </p>
          </div>
        </div>
        <nav class="p-find-navi-result-nav l-gap--xs">
          <div class="p-find-navi-result-nav__number">
            <span class="p-find-navi-result-nav__label">表示件数</span>
            <span aria-hidden="true">：</span>
            <span>{{ pageState.currentPageItemNum }}</span>
            <span>／</span>
            <span class="u-weight--bold">{{ animatedNum }}</span>件
          </div>
          <div class="p-find-navi-result-nav__show-mode">
            <span class="p-find-navi-result-nav__label">並び順</span>
            <span aria-hidden="true">：</span>
            <div>
              <label class="p-find-navi-result-nav__show-mode__button">
                <input
                  id="showUpdateOrder"
                  v-model="state.showMode"
                  :class="{'is-current': ( state.showMode == 1)}"
                  name="showMode"
                  value="1"
                  type="radio"
                  checked
                  @change="setStoredFilter"
                >
                <span>新着順</span>
              </label>
              <label
                class="p-find-navi-result-nav__show-mode__button"
                :class="{'is-disabled': (state.bookMarkIds.length == 0) }"
              >
                <input
                  id="showBookmark"
                  v-model="state.showMode"
                  :class="{'is-current': ( state.showMode == 2)}"
                  name="showMode"
                  value="2"
                  type="radio"
                  @change="showBookmark"
                >
                <span>ブックマーク<span class="bookmark-num" aria-hidden="true">{{ state.bookMarkIds.length }}</span>件</span>
              </label>
            </div>
          </div>
        </nav>
        <article
          v-for="item in pageState.list"
          :key="item.id"
          class="p-find-navi-article"
        >
          <div class="p-find-navi-article__buttons">
            <label class="p-find-navi-article__bookmark-button" aria-label="ブックマークする">
              <input
                :id="'item-' + item.id"
                v-model="state.bookMarkIds"
                :value="item.id"
                :name="'item-' + item.id"
                type="checkbox"
                @change="saveBookmark"
              >
              <span>
                <i class="c-icon" aria-hidden="true">
                  <svg class="svg-icon_check-dims">
                    <use xlink:href="/cms/wp-content/themes/mizuho-bp/assets/img/shared/sprite.symbol.svg#icon_check"></use>
                  </svg>
                </i>
              </span>
            </label>
            <a :href="item.entryUrl" class="c-button p-find-navi-article__entry-button">エントリー</a>
          </div>
          <a :href="item.articleUrl">
            <div class="p-find-navi-article__row">
              <div class="p-find-navi-article__image">
                <img
                  :src="item.thumbnail"
                  width="260"
                  height="160"
                  alt=""
                >
              </div>
              <div class="p-find-navi-article__text-area">
                <span class="c-icon-working-style">{{ item.workingStyle }}</span>
                <div class="l-gap--xss">
                  <div class="p-find-navi-article__category">
                    {{ item.operationCategory }} {{ item.jobCategory }}
                  </div>
                </div>
                <div class="l-gap--xs">
                  <h2 class="c-title-xs">
                    {{ item.title }}
                  </h2>
                </div>
                <div class="l-gap--xs">
                  <p class="c-text-sm">
                    {{ item.address }}
                  </p>
                </div>
              </div>
            </div>
            <div class="l-gap--xs">
              <p class="c-title-xs">
                {{ item.catchCopy }}
              </p>
            </div>
            <div class="l-gap--xs">
              <p class="c-text-md">
                {{ item.outline }}
              </p>
            </div>
            <div class="l-gap--sm">
              <ul class="c-list-inline">
                <li
                  v-for="val in item.workSystem"
                  :key="val.key"
                >
                  {{ val }}
                </li>
                <li
                  v-for="val in item.other"
                  :key="val.key"
                >
                  {{ val }}
                </li>
              </ul>
            </div>
          </a>
        </article>
        <pagination
          :show-pages="pageState.showPages"
          :current-page="pageState.currentPage"
          :total-count="pageState.totalCount"
          :per-page="pageState.perPage"
          :total-pages="pageState.totalPages"
          @current-page="updatePage"
        />
      </div>
    </div>
  </div>
</template>
<script>
import { computed, onMounted, reactive, ref, watch, toRefs} from 'vue';
import axios from 'axios';
import pagination from './Pagination.vue';
import { createMedia } from 'vue-use-media';
import Cookies from 'js-cookie';
import Swiper, { Navigation, Pagination } from 'swiper';
Swiper.use([Navigation,Pagination]);
import { gsap } from "gsap";

export default {
  name: 'FindNavi',
  components: {
    pagination,
  },
  setup() {
    const state = reactive({
      url: '/api/job/list_json',
      data: null,
      jobData: '',
      filterJobData: {},
      pickupJobData: {},
      searchKeyOrder: {},
      showMode: {//1:新着順,2:ブックマーク
        type: Number,
        default: 1
      },
      bookMarkIds: [],
      visibleLocation: false,
      visibleCat: '',
      media: createMedia({
        isDesktop: 'screen and (min-width: 769px)'
      })
    })

    const selectedCategory = reactive({
      catId: [],
      catArea: [],
      catLocation: [],
      catOperationCategory: [],
      catJobCategory: [],
      catWorkingStyle: [],
      catWorkSystem: [],
      catOther: [],
      isMizuhoGroup: [],
    })

    //カテゴリ名・データ定義
    const catArea = toRefs(reactive({
      name: 'area',
      label: 'エリア',
      data: []
    }))

    const catLocation = toRefs(reactive({
      name: 'location',
      label: '勤務地',
      data: []
    }))

    const catOperationCategory = toRefs(reactive({
      name: 'operationCategory',
      label: '業務区分',
      data: []
    }))

    const catJobCategory = toRefs(reactive({
      name: 'jobCategory',
      label: '職種',
      data: []
    }))

    const catWorkingStyle = toRefs(reactive({
      name: 'workingStyle',
      label: '就業形態',
      data: []
    }))

    const catWorkSystem = toRefs(reactive({
      name: 'workSystem',
      label: '働き方',
      data: []
    }))

    const catOther = toRefs(reactive({
      name: 'other',
      label: 'その他',
      data: []
    }))

    const isMizuhoGroup = toRefs(reactive({
      name: 'isMizuhoGroup',
      label: 'みずほグループのお仕事に絞る'
    }))

    //[SP]カテゴリ名のボタンで該当カテゴリのリスト表示
    const toggleCatNav = (cat='')=> {
      if(cat){
        state.visibleCat = cat;
        document.getElementsByTagName('html')[0].classList.add('is-overflow-hidden');
      }else{
        state.visibleCat = '';
        document.getElementsByTagName('html')[0].classList.remove('is-overflow-hidden');
      }
    }

    //データ取得・設定
    async function getData () {
      state.data = await axios.get(state.url);
      state.jobData = state.data.data.data;
      state.searchKeyOrder = state.data.data.searchKeyOrder;

      catArea.data.value = getCategories(catArea.name.value);
      catLocation.data.value = getCategories(catLocation.name.value);
      catJobCategory.data.value = getCategories(catJobCategory.name.value);
      catOperationCategory.data.value = getCategories(catOperationCategory.name.value);
      catWorkingStyle.data.value = getCategories(catWorkingStyle.name.value);
      catWorkSystem.data.value = getCategories(catWorkSystem.name.value);
      catOther.data.value = getCategories(catOther.name.value);

      document.getElementById('find-navi-content').classList.add('is-visible');

      //ピックアップスライドの求人票リスト
      state.pickupJobData = state.jobData.filter((item)=> {
        return (item.pickup !== 0);
      }).sort((first, second)=> {
        return (first.pickup < second.pickup) ? -1 : 1;
      });
      setBookmarkIds();
    }
    getData().catch(() => {
      document.getElementById('find-navi-content').classList.add('is-error');
    });

    //[検索サイドナビ] 存在するカテゴリリストを抽出・重複削除・ソートして返す
    const getCategories = (catName)=> {
      let jobData = state.jobData;
      let catList = [];
      let keyOrderNames = [];

      //存在する該当カテゴリの項目を結合・フラット化・重複削除
      catList = Array.from(new Set(jobData.flatMap(data => data[catName])));

      //searchKeyOrderのnameを配列化
      if(catName == 'location') {
        keyOrderNames = state.searchKeyOrder['area'].flatMap(data => data.location);
        keyOrderNames = keyOrderNames.map(data => data.name);
      }else {
        keyOrderNames = state.searchKeyOrder[catName].flatMap(data => data.name);
      }

      //searchKeyOrderに存在するカテゴリのみ抽出・ソート
      catList = keyOrderNames.filter(i => catList.indexOf(i) != -1);
      catList.sort((first, second)=> {
        return keyOrderNames.indexOf(first) - keyOrderNames.indexOf(second);
      });
      return catList;
    }

    //[検索サイドナビ] 表示するLocationリスト
    const getFilterLocationList = computed(() => {
      const areaKeyItems = Array.from(new Set(state.searchKeyOrder.area));
      const selectedAreaList = selectedCategory.catArea;
      let locationList = [];
      areaKeyItems.forEach((entry)=>{
        selectedAreaList.filter((data)=> {
          if(entry.name == data){
            locationList.push(...entry.location.flatMap(data => data.name));
          }
        })
      })
      locationList = locationList.filter(item => catLocation.data.value.includes(item));
      return locationList;
    })

    //エリアが選択解除された場合：紐づくLocationの選択も解除
    watch(() => selectedCategory.catArea, (newValues, prevValues) => {
      const deleteArea = prevValues.filter(i => newValues.indexOf(i) == -1)
      const areaKeyItems = Array.from(new Set(state.searchKeyOrder.area));
      if(deleteArea.length > 0)
      areaKeyItems.forEach((entry)=>{
        if(entry.name === deleteArea[0]){
          const deleteArr = selectedCategory.catLocation.filter(elem => {
            return !entry.location.flatMap(data => data.name).includes(elem);
          })
          selectedCategory.catLocation = deleteArr;
        }
      })
    });

    //表示する求人票Array
    const getFilterJobData = computed(() => {
      let allJobData = state.jobData;
      if(allJobData){
        let filterJobData = allJobData.filter((item) => {
          //求人票1つずつ判定
          //各カテゴリごとにフィルタ項目をtrue/falseを追加し、最後にevery判定して返す
          let itemShow = [];
          if(selectedCategory.catId.length > 0){
            return selectedCategory.catId.some((val) => {
              return String(item.id).includes(val);
            })
          }else if(selectedCategory.catArea.length > 0
            || selectedCategory.catLocation.length > 0
            || selectedCategory.catOperationCategory.length > 0
            || selectedCategory.catJobCategory.length > 0
            || selectedCategory.catWorkingStyle.length > 0
            || selectedCategory.catWorkSystem.length > 0
            || selectedCategory.catOther.length > 0
            || selectedCategory.isMizuhoGroup.length > 0){
            if(selectedCategory.catArea.length > 0){
              itemShow.push(selectedCategory.catArea.some((val) => {
                return String(item.area).includes(val);
              }))
            }
            if(selectedCategory.catLocation.length > 0){
              itemShow.push(selectedCategory.catLocation.some((val) => {
                return String(item.location).includes(val);
              }))
            }
            if(selectedCategory.catOperationCategory.length > 0){
              itemShow.push(selectedCategory.catOperationCategory.some((val) => {
                return String(item.operationCategory).includes(val);
              }))
            }
            if(selectedCategory.catJobCategory.length > 0){
              itemShow.push(selectedCategory.catJobCategory.some((val) => {
                return String(item.jobCategory).includes(val);
              }))
            }
            if(selectedCategory.catWorkingStyle.length > 0){
              itemShow.push(selectedCategory.catWorkingStyle.some((val) => {
                return String(item.workingStyle).includes(val);
              }))
            }
            if(selectedCategory.catWorkSystem.length > 0){
              itemShow.push(selectedCategory.catWorkSystem.some((val) => {
                return String(item.workSystem).includes(val);
              }))
            }
            if(selectedCategory.catOther.length > 0){
              itemShow.push(selectedCategory.catOther.some((val) => {
                return String(item.other).includes(val);
              }))
            }
            if(selectedCategory.isMizuhoGroup.length > 0){
              itemShow.push(selectedCategory.isMizuhoGroup.some((val) => {
                return String(item.isMizuhoGroup).includes(val);
              }))
            }
            return itemShow.every(value => value === true);
          }else{
            return true;
          }
        });
        return filterJobData;
      }else{
        return state.jobData;
      }
    })

    //現在のフィルター状況を保存（絞り込み条件を保存・ブックマーク表示時に保存）
    const saveSearchFilter = (valMode)=> {
      if(valMode === 'cookie'){
        let cookieArea = JSON.stringify(selectedCategory.catArea);
        let cookieLocation = JSON.stringify(selectedCategory.catLocation);
        let cookieOperationCategory = JSON.stringify(selectedCategory.catOperationCategory);
        let cookieJobCategory = JSON.stringify(selectedCategory.catJobCategory);
        let cookieWorkingStyle = JSON.stringify(selectedCategory.catWorkingStyle);
        let cookieWorkSystem = JSON.stringify(selectedCategory.catWorkSystem);
        let cookieOther = JSON.stringify(selectedCategory.catOther);
        let cookieMizuhoGroup = JSON.stringify(selectedCategory.isMizuhoGroup);

        Cookies.set( 'catArea', cookieArea, { expires: 30, path: '/'});
        Cookies.set( 'catLocation', cookieLocation, { expires: 30, path: '/'});
        Cookies.set( 'catOperationCategory', cookieOperationCategory, { expires: 30, path: '/'});
        Cookies.set( 'catJobCategory', cookieJobCategory, { expires: 30, path: '/'});
        Cookies.set( 'catWorkingStyle', cookieWorkingStyle, { expires: 30, path: '/'});
        Cookies.set( 'catWorkSystem', cookieWorkSystem, { expires: 30, path: '/'});
        Cookies.set( 'catOther', cookieOther, { expires: 30, path: '/'});
        Cookies.set( 'isMizuhoGroup', cookieMizuhoGroup, { expires: 30, path: '/'});
      }
    }

    //保存したフィルター条件を表示（保存条件で表示・新着順で表示）
    const setStoredFilter = (valMode)=> {
      if(valMode === 'cookie'){
        selectedCategory.catArea = JSON.parse(Cookies.get('catArea'));
        selectedCategory.catLocation = JSON.parse(Cookies.get('catLocation'));
        selectedCategory.catOperationCategory = JSON.parse(Cookies.get('catOperationCategory'));
        selectedCategory.catJobCategory = JSON.parse(Cookies.get('catJobCategory'));
        selectedCategory.catWorkingStyle = JSON.parse(Cookies.get('catWorkingStyle'));
        selectedCategory.catWorkSystem = JSON.parse(Cookies.get('catWorkSystem'));
        selectedCategory.catOther = JSON.parse(Cookies.get('catOther'));
        selectedCategory.isMizuhoGroup = JSON.parse(Cookies.get('isMizuhoGroup'));
      }
      //IDはリセット
      selectedCategory.catId = [];
    }

    //[ロード時]CookieのブックマークIDの求人票を精査し、state.bookMarkIds・Cookieに保存
    const setBookmarkIds = ()=> {
      state.bookMarkIds = Cookies.get('bookmarks') ? JSON.parse( Cookies.get('bookmarks') ) : [];

      //存在するIDを配列化
      let ids = state.jobData.flatMap(data => data.id);

      //存在するIDの求人票のみ抽出・ソート
      state.bookMarkIds = ids.filter(i => state.bookMarkIds.indexOf(i) != -1);

      //Cookieに保存しなおし
      saveBookmark();
    }

    //求人票ごとのブックマークIDをCookieに保存
    const saveBookmark = (item)=> {
      let serializedArr = JSON.stringify(state.bookMarkIds);

      if(item && state.bookMarkIds.length >= 16) {
        let bookMarkId = state.bookMarkIds.indexOf(item.target.value);
        item.target.checked = false
        state.bookMarkIds.splice(bookMarkId, 1);
        return
      } else {
        Cookies.set( 'bookmarks', serializedArr, { expires: 30, path: '/'});
      }
    }

    //ブックマーク表示
    const showBookmark = ()=> {
      //現在のフィルター状況をVue上で保存
      saveSearchFilter();

      //CookieのIDセットして表示
      let bookmarksGet = Cookies.get('bookmarks');
      let bookmarksJson = JSON.parse(bookmarksGet);
      selectedCategory.catId = bookmarksJson;
    }

    //絞り込みを解除
    const resetSearchFilter = ()=> {
      selectedCategory.catArea = [];
      selectedCategory.catLocation = [];
      selectedCategory.catOperationCategory = [];
      selectedCategory.catJobCategory = [];
      selectedCategory.catWorkingStyle = [];
      selectedCategory.catWorkSystem = [];
      selectedCategory.catOther = [];
      selectedCategory.isMizuhoGroup = [];
    }

    //sessionStorage 保存
    const saveSessionStorage = () => {
      sessionStorage.setItem('catArea', JSON.stringify(selectedCategory.catArea));
      sessionStorage.setItem('catLocation', JSON.stringify(selectedCategory.catLocation));
      sessionStorage.setItem('catOperationCategory', JSON.stringify(selectedCategory.catOperationCategory));
      sessionStorage.setItem('catJobCategory', JSON.stringify(selectedCategory.catJobCategory));
      sessionStorage.setItem('catWorkingStyle', JSON.stringify(selectedCategory.catWorkingStyle));
      sessionStorage.setItem('catWorkSystem', JSON.stringify(selectedCategory.catWorkSystem));
      sessionStorage.setItem('catOther', JSON.stringify(selectedCategory.catOther));
      sessionStorage.setItem('isMizuhoGroup', JSON.stringify(selectedCategory.isMizuhoGroup));
    }

    //sessionStorage 表示
    const showSessionStorage = () => {
      selectedCategory.catArea = sessionStorage.getItem('catArea') ? JSON.parse(sessionStorage.getItem('catArea')) : [];
      selectedCategory.catLocation = sessionStorage.getItem('catLocation') ? JSON.parse(sessionStorage.getItem('catLocation')) : [];
      selectedCategory.catOperationCategory = sessionStorage.getItem('catOperationCategory') ? JSON.parse(sessionStorage.getItem('catOperationCategory')) : [];
      selectedCategory.catJobCategory = sessionStorage.getItem('catJobCategory') ? JSON.parse(sessionStorage.getItem('catJobCategory')) : [];
      selectedCategory.catWorkingStyle = sessionStorage.getItem('catWorkingStyle') ? JSON.parse(sessionStorage.getItem('catWorkingStyle')) : [];
      selectedCategory.catWorkSystem = sessionStorage.getItem('catWorkSystem') ? JSON.parse(sessionStorage.getItem('catWorkSystem')) : [];
      selectedCategory.catOther = sessionStorage.getItem('catOther') ? JSON.parse(sessionStorage.getItem('catOther')) : [];
      selectedCategory.isMizuhoGroup = sessionStorage.getItem('isMizuhoGroup') ? JSON.parse(sessionStorage.getItem('isMizuhoGroup')) : [];
    }

    /* ページネーション設定 */
    const pageState = reactive({
      perPage: 20,
      showPages: 3,
      currentPage: 1,
      totalCount: 0,
      totalPages: 0,
      list: [],
      currentPageItemNum: 0
    });
    pageState.totalCount = computed(() => {
      return getFilterJobData.value.length;
    })
    pageState.totalPages = computed(() => {
      return Math.ceil(pageState.totalCount / pageState.perPage);
    })
    //ページ変更時
    const updatePage = (currentPage = 1) => {
      pageState.currentPage = currentPage;
      document.querySelector('#p-find-navi-top').scrollIntoView({
        block: 'start',
      });
    };
    //1ページ分の記事
    pageState.list = computed(() => {
      let current = pageState.currentPage * pageState.perPage;
      let start = current - pageState.perPage;
      let itemList = getFilterJobData.value;
      let newItemList = itemList.slice(start, current);
      return newItemList;
    })
    //1ページ分の記事数
    pageState.currentPageItemNum = computed(() => {
      return pageState.list.length + (pageState.currentPage - 1) * pageState.perPage;
    })

    /* 検索結果件数：アニメーション付き */
    const tweenedNum = ref(0);
    const animatedNum = computed(() => {
      return tweenedNum.value.toFixed(0);
    })
    watch(() => getFilterJobData.value.length, (newValues) => {
      gsap.to(tweenedNum, {duration:0.6, value: newValues});
    })

    //フィルター更新時
    watch(() => getFilterJobData.value, ()=> {
      //ページ数リセット
      pageState.currentPage = 1;
      saveSessionStorage();
      //SP時：検索結果先頭へスクロール
      if(!state.media.isDesktop){
        document.querySelector('#p-find-navi-top').scrollIntoView({
          block: 'start',
        });
      }
    })

    /* 初回検索描画後 */
    const afterShowContents = ()=> {
      const cont = document.querySelector('.p-find-navi-wrapper');
      const observerMain = new MutationObserver(()=> {
        observerMain.disconnect();
        //ブラウザバック時のみセッション保存されたY地点へスクロール
        (() => {
          let entries = performance.getEntriesByType('navigation');
          entries.forEach((entry) => {
            if ((entry.type == 'back_forward' || entry.type == 'reload') && sessionStorage.getItem('scrollY') != null) {
              window.scrollTo(0, sessionStorage.getItem('scrollY'));
            }
          });
        })();

        //右付きFixedナビ
        const headerH = document.getElementById('header-navigation').getBoundingClientRect().height;
        const target = document.getElementById('js-find-navi-pc-fixed-nav');
        const exclude = document.querySelector(target.dataset.showExclude);
        //表示タイミング（デフォルトはページヘッダーが過ぎた時）
        const handleObserveStart = (elems) => {
          elems.forEach((elem) => {
            if (elem.isIntersecting) {
              target.classList.remove('is-show');
            }else{
              target.classList.add('is-show');
            }
          });
        }
        const observerOptionsStart = {
          root: null,
          rootMargin: `-${headerH}px 0px 0px 0px`,
          threshold: 0
        };
        const observerStart = new IntersectionObserver(handleObserveStart, observerOptionsStart);

        if(exclude){
          observerStart.observe(exclude);
        }else{
          target.classList.add('is-show');
        }
      });
      observerMain.observe(cont, {
        childList: true,
        subtree: true
      });
    }

    /* スライド設定 */
    const createSlider = ()=> {
      const swiperSlide = document.querySelector('#js-find-navi-pickup__slider');
      const pcViewNum = 3;
      const observer = new MutationObserver(()=> {
        const swiperItem = document.querySelectorAll('.swiper-slide');
        if(swiperItem.length < pcViewNum) swiperSlide.classList.add('is-pc-disabled')
        new Swiper(swiperSlide, {
          spaceBetween: 8,
          slidesPerView: 'auto',
          pagination: {
            el: '.p-find-navi-pickup__pagination',
            type: 'bullets',
            clickable: true
          },
          navigation: {
            nextEl: '.p-find-navi-pickup__next',
            prevEl: '.p-find-navi-pickup__prev',
          },
          breakpoints: {
            769: {
              slidesPerView: pcViewNum,
            },
          }
        });
        observer.disconnect();
      });
      if(swiperSlide){
        swiperSlide.classList.remove('swiper-disabled');
        const target = swiperSlide;
        observer.observe(target, {
          childList: true,
          subtree: true
        });
      }
    }

    onMounted(async () => {
      state.showMode = 1;
      afterShowContents();
      createSlider();
      //セッション保存された検索結果表示
      showSessionStorage();
      //セッションにY座標保存
      window.addEventListener('beforeunload', () => {
        sessionStorage.setItem('scrollY', window.scrollY);
      });
    })

    return{
      state,
      pageState,
      selectedCategory,
      catArea,
      catLocation,
      catOperationCategory,
      isMizuhoGroup,
      catJobCategory,
      catWorkingStyle,
      catWorkSystem,
      catOther,
      toggleCatNav,
      getData,
      setStoredFilter,
      setBookmarkIds,
      saveBookmark,
      showBookmark,
      saveSearchFilter,
      resetSearchFilter,
      getFilterLocationList,
      getFilterJobData,
      updatePage,
      createSlider,
      saveSessionStorage,
      showSessionStorage,
      animatedNum
    }
  },
}
</script>
